"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDescriptionTextForLSD = exports.apisData = exports.rpcFeedsCatalog = void 0;
exports.getDecodedParameters = getDecodedParameters;
exports.getAirnodeAddressByAlias = getAirnodeAddressByAlias;
exports.getApiProviderAliases = getApiProviderAliases;
exports.getOisTitlesWithAirnodeAddress = getOisTitlesWithAirnodeAddress;
exports.getOisTitleByFeedNameAndAirnodeAddress = getOisTitleByFeedNameAndAirnodeAddress;
exports.deriveDataFeedId = deriveDataFeedId;
exports.deriveTemplateId = deriveTemplateId;
exports.deriveEndpointId = deriveEndpointId;
exports.getSupportedProvidersForDataFeed = getSupportedProvidersForDataFeed;
exports.getAllDataFeeds = getAllDataFeeds;
exports.getApiUrls = getApiUrls;
const ethers_1 = require("ethers");
const airnode_abi_1 = require("@api3/airnode-abi");
const contracts_1 = require("@api3/contracts");
const lodash_1 = __importDefault(require("lodash"));
const apis_1 = require("./generated/apis");
const catalog_1 = require("./rpc/catalog");
const oisTitles_json_1 = __importDefault(require("../data/oisTitles.json"));
var catalog_2 = require("./rpc/catalog");
Object.defineProperty(exports, "rpcFeedsCatalog", { enumerable: true, get: function () { return catalog_2.rpcFeedsCatalog; } });
var apis_2 = require("./generated/apis");
Object.defineProperty(exports, "apisData", { enumerable: true, get: function () { return apis_2.apisData; } });
const MAX_POSSIBLE_DEPTH = 10;
function getDecodedParameters(feedName) {
    return [{ name: 'name', type: 'string32', value: feedName }];
}
function getAirnodeAddressByAlias(alias) {
    return apis_1.apisData[alias].airnode;
}
function getApiProviderAliases() {
    return Object.values(apis_1.apisData).map((d) => d.alias);
}
function getOisTitlesWithAirnodeAddress(airnodeAddress) {
    return oisTitles_json_1.default[airnodeAddress];
}
function getOisTitleByFeedNameAndAirnodeAddress(feedName, airnodeAddress) {
    const apis = Object.values(apis_1.apisData);
    const targetApiData = apis.find((a) => a.airnode === airnodeAddress);
    if (!targetApiData) {
        throw Error(`Couldn't find any API with Airnode address ${airnodeAddress}`);
    }
    // find which OIS includes the data feed
    const targetOisTitle = Object.keys(targetApiData.supportedFeedsInBatches).find((oisTitle) => {
        return targetApiData.supportedFeedsInBatches[oisTitle].flat().includes(feedName);
    });
    if (!targetOisTitle) {
        throw Error(`Data feed ${feedName} does not exists in ${targetApiData.alias}.`);
    }
    return targetOisTitle;
}
function deriveDataFeedId(feedName, airnodeAddress) {
    const targetOisTitle = getOisTitleByFeedNameAndAirnodeAddress(feedName, airnodeAddress);
    const templateId = deriveTemplateId({ oisTitle: targetOisTitle, feedName: feedName });
    return ethers_1.ethers.utils.solidityKeccak256(['address', 'bytes32'], [airnodeAddress, templateId]);
}
function deriveTemplateId(inputs) {
    const { feedName, oisTitle, airnodeAddress } = inputs;
    if (oisTitle) {
        const endpointId = deriveEndpointId({ oisTitle: oisTitle });
        const parameters = (0, airnode_abi_1.encode)([{ name: 'name', type: 'string32', value: feedName }]);
        return ethers_1.ethers.utils.solidityKeccak256(['bytes32', 'bytes'], [endpointId, parameters]);
    }
    if (!airnodeAddress) {
        throw new Error('airnodeAddress must be provided');
    }
    const targetOisTitle = getOisTitleByFeedNameAndAirnodeAddress(feedName, airnodeAddress);
    const parameters = (0, airnode_abi_1.encode)([{ name: 'name', type: 'string32', value: feedName }]);
    const endpointId = deriveEndpointId({ oisTitle: targetOisTitle });
    return ethers_1.ethers.utils.solidityKeccak256(['bytes32', 'bytes'], [endpointId, parameters]);
}
function deriveEndpointId(input) {
    const endpointName = 'feed';
    const { oisTitle, airnodeAddress } = input;
    if (oisTitle) {
        const existingOisTitles = Object.values(oisTitles_json_1.default).flat();
        if (existingOisTitles.includes(oisTitle)) {
            return ethers_1.ethers.utils.keccak256(ethers_1.ethers.utils.defaultAbiCoder.encode(['string', 'string'], [oisTitle, endpointName]));
        }
        else {
            throw Error(`Can't derive endpoint ID. The OIS title ${oisTitle} is not existing in the current OISes!`);
        }
    }
    if (airnodeAddress) {
        const existingAirnodeAddresses = Object.keys(oisTitles_json_1.default);
        if (existingAirnodeAddresses.includes(airnodeAddress)) {
            const targetOisTitles = getOisTitlesWithAirnodeAddress(airnodeAddress);
            const endpointIds = targetOisTitles.map((title) => {
                return ethers_1.ethers.utils.keccak256(ethers_1.ethers.utils.defaultAbiCoder.encode(['string', 'string'], [title, endpointName]));
            });
            return endpointIds;
        }
        else {
            throw Error(`Can't derive endpoint ID. The Airnode Address ${airnodeAddress} is not existing in the current Airnode addresses!`);
        }
    }
    throw Error("Must set an 'airnodeAddress' or 'oisTitle'!");
}
function getSupportedProvidersForDataFeed(dataFeedName) {
    return Object.values(apis_1.apisData)
        .filter((apiData) => {
        const dataFeeds = Object.values(apiData.supportedFeedsInBatches)
            .map((feeds) => feeds)
            .flat(MAX_POSSIBLE_DEPTH);
        if (dataFeeds.includes(dataFeedName)) {
            return true;
        }
        return false;
    })
        .map((apiData) => apiData.alias);
}
function getAllDataFeeds() {
    const allFeeds = Object.values(apis_1.apisData)
        .map((apiData) => {
        const dataFeeds = Object.values(apiData.supportedFeedsInBatches)
            .map((feeds) => feeds)
            .flat(MAX_POSSIBLE_DEPTH);
        return dataFeeds;
    })
        .flat(MAX_POSSIBLE_DEPTH);
    const uniqueFeeds = lodash_1.default.uniq(allFeeds);
    return uniqueFeeds;
}
function getApiUrls(airnodeAddress) {
    const targetApiData = Object.values(apis_1.apisData).find((apiData) => apiData.airnode === airnodeAddress);
    if (!targetApiData) {
        throw `Couldn't find the Airnode address ${airnodeAddress}!`;
    }
    return {
        name: targetApiData.name,
        alias: targetApiData.alias,
        homepageUrl: targetApiData.homepageUrl,
        verifiedBaseUrl: targetApiData.verifiedBaseUrl,
        signedApiUrl: targetApiData.signedApiUrl
    };
}
const generateDescriptionTextForLSD = (feedName) => {
    const feed = catalog_1.rpcFeedsCatalog.find((rpcFeed) => rpcFeed.name === feedName);
    if (!feed) {
        throw new Error(`Couldn't find ${feedName} in RPC feed catalog.`);
    }
    const getChainName = (chainAlias) => {
        const chain = contracts_1.CHAINS.find((chain) => chain.alias === chainAlias);
        if (!chain) {
            throw new Error(`Chain not found for alias ${chainAlias}`);
        }
        return chain.name;
    };
    const chainName = getChainName(feed.chainAlias);
    const prettifyParametersDescription = (parameters) => {
        switch (parameters.length) {
            case 0: {
                return '';
            }
            case 1: {
                return `${parameters[0]}`;
            }
            default: {
                return `${parameters.join(', ')}`;
            }
        }
    };
    switch (feed.returnType) {
        case 'type-0': {
            return `* The value returned by ${feed.contractMethods[0]}(${prettifyParametersDescription(feed.contractMethodsParameters[0])}) of ${feed.contractAddress} on ${chainName} is called A.* ${feed.name} reports the value A as an 18-decimal fixed-point integer.`;
        }
        case 'type-1': {
            return `* The values returned by ${feed.contractMethods[0]}(${prettifyParametersDescription(feed.contractMethodsParameters[0])}) of ${feed.contractAddress} on ${chainName} are called A.* ${feed.name} reports the first element A[0] as an 18-decimal fixed-point integer.`;
        }
        case 'type-2': {
            return `* The values returned by ${feed.contractMethods[0]}(${prettifyParametersDescription(feed.contractMethodsParameters[0])}) of ${feed.contractAddress} on ${chainName} are called A.* ${feed.name} reports the result of (A[1] / A[2]) as an 18-decimal fixed-point integer.`;
        }
        case 'type-3': {
            return `* The value returned by ${feed.contractMethods[0]}(${prettifyParametersDescription(feed.contractMethodsParameters[0])}) of ${feed.contractAddress} on ${chainName} is called A.* The values returned by ${feed.contractMethods[1]}(${prettifyParametersDescription(feed.contractMethodsParameters[1])}) of ${feed.contractAddress} on ${chainName} are called B.* ${feed.name} reports the result of (A - B[2]) as an 18-decimal fixed-point integer.`;
        }
        default: {
            throw new Error(`Unsupported return type ${feed.returnType}`);
        }
    }
};
exports.generateDescriptionTextForLSD = generateDescriptionTextForLSD;
//# sourceMappingURL=index.js.map